export default __webpack_public_path__ + "static/media/xls.f29d7b9d.svg";